import React, { useState, useEffect } from "react";
import BreadcrumbsComponent from "../../../../components/BreadcrumbsComponent";
import { Tooltip, Typography } from "@mui/material";
import LinkRoundedIcon from "@mui/icons-material/LinkRounded";
import MoreHorizRoundedIcon from "@mui/icons-material/MoreHorizRounded";
import Inventory2RoundedIcon from "@mui/icons-material/Inventory2Rounded";
import FolderRoundedIcon from "@mui/icons-material/FolderRounded";
import LayersRoundedIcon from "@mui/icons-material/LayersRounded";
import DirectionsRunRoundedIcon from "@mui/icons-material/DirectionsRunRounded";
import ProjectIssues from "../../../../components/ProjectIssues";
import AddPeopleToProject from "../AddPeopleToProject";
import BacklogHeader from "../../../../components/BaclogHeader";
import { useDispatch, useSelector } from "react-redux";
import { NormalSkeleton } from "../../../../common/Skeleton";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import { updateIssue, getSprintsList, getBacklogIssues } from "../../../../common/Redux/Reducer";
import axios from "axios";
import API_BASE_URL from "../../../../components/config/appConfig";
import TaskWorkFlowModalPage from "../../../../components/Modal/TaskWorkFlow";
import BoltIcon from "@mui/icons-material/Bolt";
import { useSearchParams } from "react-router-dom";
import { useToast } from "../../../../components/Toast";
import { usePageSearch } from "../../../../context/PageSearchContext";
import "./backlogpage.scss";

const BacklogPage = () => {
  const [searchParams, setSearchparams] = useSearchParams();
  let urlQueryObj = Object.fromEntries([...searchParams]);
  const [openGallery, setOpenGallery] = useState(true);
  const [SprintIndex, setSprintIndex] = useState(null);
  const [loading] = useState(false);
  const [openselectedIssue, setOpenSelectedIssue] = useState(false);
  const [openselectedSprintIssue, setOpenSelectedSprintIssue] = useState(urlQueryObj?.selectedIssue ? urlQueryObj?.selectedIssue : false);
  const [selectedIssueName] = useState(urlQueryObj?.selectedIssue || null);

  const [openAddPeopleModel, setOpenAddPeopleModel] = useState(false);
  const { Projects, Skeleton, assignees } = useSelector((state) => state.ProjamAppSlice);
  const sprintDataList = Projects?.selectedProject?.sprintsList;
  const activeSprint = Projects?.selectedProject?.ActiveSprint;
  const IssuesInBacklog = Projects?.selectedProject?.backlogIssuesList;
  const projectEpicData = Projects?.selectedProject?.selectedProjectEpicsData;
  const totalBacklogIssues = IssuesInBacklog?.length || 0;

  /* shared with the top bar, so either box filters the backlog */
  const [searchTerm, setSearchTerm] = usePageSearch("Search backlog issues…");
  const [isActiveSprintExist, setIsActiveSprintExist] = useState(false);
  const [projectIssuesData, setSprintsDataList] = useState([]);
  const [selectedTaskType, setSelectedTaskType] = useState("");
  const [selectPriorityType, setSelectPriorityType] = useState("");
  const [workFlowModalData, setWorkFlowModalData] = useState({});
  const dispatch = useDispatch();
  const toast = useToast();
  const [selectedEpic, setSelectedEpic] = useState("");
  const [selectedProjectEpicsData, setselectedProjectEpicsData] = useState([]);

  const handleSearch = (text) => {
    setSearchTerm(text);
  };

  const handleClick = (index) => {
    setSprintIndex(index);
    setOpenGallery(!openGallery);
  };
  let BacklogId = Projects?.selectedProject?.selectedProjectBackLogId;
  let ProjectName = Projects?.selectedProject?.selectedProjectData?.title;

  useEffect(() => {
    if (sprintDataList && sprintDataList?.length > 0) {
      setSprintsDataList(sprintDataList);
      checkForActiveSprint();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sprintDataList]);

  useEffect(() => {
    if (projectEpicData) {
      const updatedProjectEpicData = projectEpicData?.map((eachData) => ({
        ...eachData,
        icon: (
          <span className="epic-icon-cls">
            <BoltIcon sx={{ color: "#fff", height: "0.7rem", fontSize: "1rem" }} />
          </span>
        ),
      }));
      setselectedProjectEpicsData(updatedProjectEpicData || []);
    }
  }, [projectEpicData]);

  const handleSprintIssueClick = (issue) => {
    setOpenSelectedSprintIssue(true);
    setWorkFlowModalData(issue);
    setSearchparams({ selectedIssue: issue?.name });
  };

  const handleCopyUrl = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      toast.success("Link copied");
    } catch (error) {
      toast.error("Could not copy the link");
    }
  };

  const handleIssueClick = (issue) => {
    setOpenSelectedIssue(true);
    setWorkFlowModalData(issue);
    setSearchparams({ selectedIssue: issue?.name });
  };

  const handleCloseClick = () => {
    setOpenSelectedIssue(false);
    setOpenSelectedSprintIssue(false);
  };

  const handleStatuUpdate = (value) => {
    setSelectedTaskType(value || "");
  };

  const handlePriorityUpdate = (priority) => {
    setSelectPriorityType(priority);
  };

  const onDragEnd = async (result) => {
    if (!result?.destination) return;

    const { source, destination, draggableId } = result;
    try {
      if (destination?.droppableId !== source?.droppableId) {
        if (destination.droppableId === "backlog") {
          await dispatch(updateIssue({ issueId: draggableId, payload: { sprint: null } }));
        } else {
          await axios.put(`${API_BASE_URL}/issues/moveto/sprint/${destination.droppableId}`, { selectedIssues: [draggableId] });
        }
        await dispatch(getSprintsList({ backlogId: BacklogId, filterAssigneesArray: assignees }));
        await dispatch(getBacklogIssues(BacklogId));
      }
      handleCloseClick();
    } catch (error) {
      console.error("An error occurred while updating the issue or fetching data:", error);
      toast.error("Could not move the issue");
    }
  };

  const checkForActiveSprint = async () => {
    try {
      let activeSprints = sprintDataList.filter((sprint) => sprint.active === true);
      let remainingSprints = sprintDataList.filter((sprint) => sprint.active !== true);
      if (activeSprints && activeSprints.length > 0) {
        setSprintsDataList([...activeSprints, ...remainingSprints]);
        setIsActiveSprintExist(true);
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  const handleEpicData = (data) => {
    setSelectedEpic(data);
  };

  const sprintCount = projectIssuesData?.length || 0;
  const liveSprint = (projectIssuesData || []).find((sprint) => sprint?.active);

  return (
    <div className="backlog-page-main-container">
      {/* ------------------------------------------------------------ header */}
      <section className="bl-hero">
        <div className="bl-hero__top">
          <div className="bl-hero__crumbs">
            {!Skeleton ? <BreadcrumbsComponent /> : <NormalSkeleton width={200} extraStyles="my-1" />}
          </div>
          <div className="bl-hero__actions">
            <Tooltip title="Copy link to this backlog">
              <button type="button" className="bl-icon-btn" onClick={handleCopyUrl} aria-label="Copy backlog link">
                <LinkRoundedIcon />
              </button>
            </Tooltip>
            <button type="button" className="bl-icon-btn hover-disable d-none d-md-inline-grid" aria-label="More actions" aria-disabled="true">
              <MoreHorizRoundedIcon />
            </button>
          </div>
        </div>

        <div className="bl-hero__main">
          {!Skeleton ? (
            <div className="bl-hero__identity">
              <span className="bl-hero__tile" aria-hidden="true">
                <Inventory2RoundedIcon />
              </span>
              <div className="bl-hero__heading">
                <Typography component="h1" className="backlog-title">
                  Backlog
                </Typography>
                <div className="bl-hero__meta">
                  {ProjectName ? (
                    <span className="bl-meta-chip">
                      <FolderRoundedIcon />
                      {ProjectName}
                    </span>
                  ) : null}
                  <span className="bl-meta-chip">
                    <LayersRoundedIcon />
                    {totalBacklogIssues} {totalBacklogIssues === 1 ? "issue" : "issues"} waiting to be planned
                  </span>
                  {sprintCount ? (
                    <span className={`bl-meta-chip ${liveSprint ? "is-live" : ""}`}>
                      {liveSprint ? <span className="bl-live-dot" /> : <DirectionsRunRoundedIcon />}
                      {liveSprint ? `${liveSprint.name} is running` : `${sprintCount} ${sprintCount === 1 ? "sprint" : "sprints"} planned`}
                    </span>
                  ) : null}
                </div>
              </div>
            </div>
          ) : (
            <NormalSkeleton width={240} extraStyles="my-1" />
          )}
        </div>

        <div className="bl-toolbar">
          <BacklogHeader
            className="bl-filters"
            menuClassName="bl-filter-menu"
            popoverClassName="bl-people-pop"
            setOpenAddPeopleModel={setOpenAddPeopleModel}
            searchTerm={searchTerm}
            handleSearch={handleSearch}
            handlePriorityUpdate={handlePriorityUpdate}
            handleStatuUpdate={handleStatuUpdate}
            selectedTaskType={selectedTaskType}
            selectPriorityType={selectPriorityType}
            EpicsData={selectedProjectEpicsData}
            handleEpicData={handleEpicData}
            selectedEpic={selectedEpic}
          />
        </div>
      </section>

      {/* ------------------------------------------------ sprints + backlog */}
      <DragDropContext onDragEnd={onDragEnd}>
        {!Skeleton ? (
          <div className="bl-lists">
            {!loading &&
              projectIssuesData?.length > 0 &&
              projectIssuesData.map((sprint, index) => (
                <Droppable key={sprint?._id} droppableId={sprint?._id || `sprint-${index}`} direction="vertical">
                  {(provided) => (
                    <div ref={provided.innerRef} {...provided.droppableProps}>
                      <ProjectIssues
                        key={sprint?._id}
                        isActiveSprintExist={isActiveSprintExist}
                        setIsActiveSprintExist={setIsActiveSprintExist}
                        openGallery={openGallery}
                        onClick={(clickedIndex) => handleClick(clickedIndex)}
                        name={sprint?.name}
                        issues={sprint?.issues}
                        index={index}
                        sprintData={sprint}
                        SprintIndex={SprintIndex}
                        setSprintIndex={setSprintIndex}
                        sprint={sprint?._id}
                        handleSprintIssueClick={handleSprintIssueClick}
                        searchTerm={searchTerm}
                        AllsprintDetails={projectIssuesData}
                        setOpenSelectedSprintIssue={setOpenSelectedSprintIssue}
                        IssuecountObj={sprint?.IssuecountObj}
                        activeSprint={activeSprint}
                        selectedIssueType={selectedTaskType}
                        selectPriorityType={selectPriorityType}
                        selectedEpic={selectedEpic}
                      />
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              ))}
            {!loading && (
              <Droppable droppableId="backlog" direction="vertical">
                {(provided) => (
                  <div ref={provided.innerRef} {...provided.droppableProps}>
                    <ProjectIssues
                      openGallery={openGallery}
                      onClick={handleClick}
                      name={"backlog"}
                      index={projectIssuesData?.length || 0}
                      issues={IssuesInBacklog}
                      handleIssueClick={handleIssueClick}
                      searchTerm={searchTerm}
                      AllsprintDetails={projectIssuesData}
                      selectedIssueType={selectedTaskType}
                      selectPriorityType={selectPriorityType}
                      selectedEpic={selectedEpic}
                    />
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            )}
          </div>
        ) : (
          <div className="py-4 px-3">
            <NormalSkeleton variant="rectangular" height={300} width="100%" />
          </div>
        )}
      </DragDropContext>

      {openAddPeopleModel && (
        <AddPeopleToProject open={openAddPeopleModel} ProjectName={ProjectName} setOpenAddPeopleModel={setOpenAddPeopleModel} />
      )}

      {openselectedSprintIssue && (
        <TaskWorkFlowModalPage
          open={openselectedSprintIssue}
          handleChangeModalOpen={() => setOpenSelectedSprintIssue(!openselectedSprintIssue)}
          selectedissueId={workFlowModalData?._id}
          issueName={selectedIssueName}
        />
      )}
      {openselectedIssue && (
        <TaskWorkFlowModalPage
          open={openselectedIssue}
          handleChangeModalOpen={() => setOpenSelectedIssue(!openselectedIssue)}
          selectedissueId={workFlowModalData?._id}
          issueName={selectedIssueName}
        />
      )}
    </div>
  );
};

export default BacklogPage;
